import { CopyrightImage } from '../types'

export const createEmptyCopyrightImage = (): CopyrightImage => ({
  url: '',
  source_url: '',
  source: '',
  copyright_file: null,
})
